import React, { useCallback, useState } from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'

import Input from '../../../../../../../components/Form/Input'

import Select from '../../../../../../../components/Form/Select'

import { ContainerButton } from './styles'
import { BoxContainer, Button } from '../../../../../../../components'
import { Form, FormBody } from '../../../../../../../components/Form/styles'
import {
  ecbrUserRoleListForSelect,
  Roles
} from '../../../../../../../constants/roles'
import ecbrApi from '../../../../../../../services/ecbrApi'
import ErrorMessage from '../../../../../../../components/Form/ErrorMessage'
import { UserEvents } from '../constants'
import { extractErrorMessage } from '../../../../../../../helpers/extractErrorMessage'
import SelectAsync from '../../../../../../../components/Form/SelectAsync'
import {
  adminLoadCertificateOptions,
  adminLoadPillarOptions
} from '../../../../../../../helpers/loadOptions'
import { ComponentTitle } from '../../../../../styles'
import useUrlParam from '../../../../../../../hooks/useUrlParam'

const initialValues = {
  name: '',
  email: '',
  role: '',
  certificate: undefined,
  pillars: undefined
}

const formSchema = Yup.object().shape({
  name: Yup.string().required('Campo obrigatório'),
  email: Yup.string().required('Campo obrigatório').email('Email inválido'),
  role: Yup.string()
    .transform((_, obj) => obj?.value ?? undefined)
    .required('Campo obrigatório'),
  certificate: Yup.number()
    .transform((_, obj) => obj?.value ?? undefined)
    .optional(),
  pillars: Yup.number()
    .transform((_, obj) => obj?.value ?? undefined)
    .optional()
})

const SendInvites = ({ eventListener }) => {
  const [error, setError] = useState('')
  const [companyId, brandId] = useUrlParam(
    '/admin/companies/:id/brands/:id/details'
  )

  const onSubmit = useCallback(
    async (values, { setSubmitting, resetForm }) => {
      try {
        setError('')
        setSubmitting(true)
        const { role, certificate, pillars, ...rest } = values

        const pillarIds =
          role.value === Roles.PILLAR_OWNER
            ? pillars?.map((p) => Number(p?.value))
            : []

        const data = {
          ...rest,
          role: role.value,
          ...(certificate && { certificateId: certificate.value }),
          pillarIds,
          companyId: Number(companyId)
        }

        await ecbrApi.userInvites.invite(data)
        resetForm()
        eventListener?.publish(UserEvents.INVITE_SENT)
        setSubmitting(false)
      } catch (err) {
        console.log({ err })

        const errorMessage = extractErrorMessage(err, 'Erro ao enviar convite')
        setError(errorMessage)
        setSubmitting(false)
      }
    },
    [companyId, eventListener]
  )

  return (
    <BoxContainer>
      <ComponentTitle>Enviar convites</ComponentTitle>

      <Formik
        initialValues={initialValues}
        validationSchema={formSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting, getFieldProps }) => (
          <Form maxWidth="100%" margin="0">
            <FormBody type="flex" justifyContent="flex-start" flexRow>
              <Input
                name="name"
                label="Nome de usuário"
                showValidIcon
                display="inline-block"
                width="230px"
                fontSizeLabel="12px"
              />
              <Input
                name="email"
                label="E-mail de acesso"
                display="inline-block"
                width="210px"
                fontSizeLabel="12px"
              />
              <Select
                name="role"
                label="Perfil"
                options={ecbrUserRoleListForSelect}
                optionValue="value"
                optionLabel="label"
                width="210px"
                fontSizeLabel="12px"
              />
              {getFieldProps('role').value?.value === Roles.PILLAR_OWNER &&
              brandId ? (
                <SelectAsync
                  name="certificate"
                  label="Certificado"
                  loadOptions={adminLoadCertificateOptions(Number(brandId))}
                  width="230px"
                  fontSizeLabel="12px"
                />
              ) : (
                <Select
                  name="certificate"
                  label="Certificado"
                  width="230px"
                  fontSizeLabel="12px"
                  isDisabled
                  isOptionDisabled={() => true}
                />
              )}
              {getFieldProps('certificate').value?.value &&
              getFieldProps('role').value?.value === Roles.PILLAR_OWNER ? (
                <SelectAsync
                  name="pillars"
                  label="Pilares"
                  loadOptions={adminLoadPillarOptions(
                    getFieldProps('certificate').value?.value
                  )}
                  isMulti
                  optionValue="value"
                  optionLabel="label"
                  width="auto"
                  minWidth="200px"
                  fontSizeLabel="12px"
                  disabled={!getFieldProps('certificate').value?.value}
                />
              ) : (
                <Select
                  name="pillars"
                  label="Pilares"
                  width="auto"
                  minWidth="200px"
                  fontSizeLabel="12px"
                  isDisabled
                  isOptionDisabled={() => true}
                />
              )}
              <ContainerButton>
                <Button
                  text={isSubmitting ? 'Enviando...' : 'Enviar convite'}
                  type="submit"
                  variant="primary"
                  width="120px"
                  disabled={isSubmitting}
                />
              </ContainerButton>
            </FormBody>
            <ErrorMessage>{error}</ErrorMessage>
          </Form>
        )}
      </Formik>
    </BoxContainer>
  )
}

export default SendInvites
